export default __webpack_public_path__ + "static/media/worker.0008b1d9.svg";